import { forwardRef, type PropsWithChildren } from "react";
import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import { ScrollArea, type ScrollAreaHandle } from "@/components/flexkit/ScrollArea";

export const StepListContainer = forwardRef<ScrollAreaHandle, PropsWithChildren<PropsWithClassName>>(
    ({ className, children }, ref) => {
        return (
            <ScrollArea
                ref={ref}
                autoScroll={false}
                orientation="vertical"
                id="step-list-container-scrollarea"
                className={cn(
                    "flex grow flex-col rounded-lg border border-border-subtle bg-surface-primary bg-[image:radial-gradient(circle,rgb(var(--border-subtle)/var(--border-subtle-opacity))_1.5px,transparent_1.5px)] bg-[length:15px_15px]",
                    className,
                )}
            >
                <div data-automation-edit-container className="relative flex grow items-start justify-center px-6 py-6">
                    {children}
                </div>
            </ScrollArea>
        );
    },
);
StepListContainer.displayName = "StepListContainer";
